import React, { useContext, useRef, useState } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import EditBook from './EditBook';
import ModalWrapper from '../../components/ModalWrapper';
import { Main, Header, Body } from '../../NecttosComp/Layout/Layout';
import { Table, Thead, Tr, Th, Tbody, Td } from '../../NecttosComp/Table/Table';
import { Select } from 'antd';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

const getFieldDropDowns = (data) => async () => {
	let { setLoading } = data;
	setLoading(true);
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/library/getOpac', {
			params: { ...data },
		});
		setLoading(false);
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		}
		return resp?.data?.opacData[0];
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const Master = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [state, setState] = useState({ filterValue: '', page: 0 });
	const componentRef = useRef();
	const [loading, setLoading] = useState(false);
	const [items, setItems] = useState({ addBook: false });

	const { data = [], refetch } = useQuery(
		['opacData', state.searchType, state.searchValue, state.page],
		getFieldDropDowns({
			collegeId,
			searchType: state.searchType,
			searchValue: state.searchValue,
			skip: state.page * 50,
			setLoading,
		}),
		{ keepPreviousData: true },
	);

	const { Option } = Select;
	const filterTypeDrops = ['All', 'Title', 'Author', 'Subjects', 'Call No', 'Accession No', 'Contents'];

	return (
		<Main title='Master Book List' width='100%' height='100%'>
			<Header className='flex flex-col lg:flex-row flex-wrap justify-between items-start lg:items-center p-4 gap-4'>
				<div className='flex flex-wrap items-center gap-3 w-full lg:w-auto'>
					<Input2 type='drop' fieldName='Filter Type' returnKey='searchType' state={state} setState={setState} options={filterTypeDrops.map((type) => ({ label: type, value: type }))} optionDisplay='label' optionKey='value' className='w-[260px]' inputClass='text-sm' />

					<Input2 type='text' fieldName='Search By All' returnKey='searchValue' state={state} setState={setState} placeholder={`Search by ${state.searchType || 'All'}`} className='w-[300px]' />
				</div>

				<div className='flex flex-wrap items-center justify-end gap-3 w-full lg:w-auto'>
					<Button type='update' disabled={parseInt(state.page) < 1} onClick={() => setState({ ...state, page: parseInt(state.page) - 1 })}>
						Prev
					</Button>

					<span className='font-medium text-sm text-slate-700 dark:text-slate-100 whitespace-nowrap'>
						Page {parseInt(state.page) + 1} | Showing {state.page * 50 + 1} - {state.page * 50 + 50} of {data?.total?.[0]?.total || 0}
					</span>

					<Button type='update' disabled={parseInt(state.page) * 50 > parseInt(data?.total?.[0]?.total) - 50} onClick={() => setState({ ...state, page: parseInt(state.page) + 1 })}>
						Next
					</Button>

					<Button type='fetch' onClick={refetch}>
						Reload
					</Button>

					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId={'master'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

			<Body>
				{loading ? (
					<LoadingAnimation />
				) : (
					<div ref={componentRef} className='printable dark:bg-neutral-800 p-4 rounded-xl overflow-x-auto'>
						<div className='min-w-[1000px]'>
							<Table width='100%' innerWidth={['4%', '40%', '20%', '4%', '20%', '20%', '10%', '10%', '10%']}>
								<Thead>
									<Tr>
										<Th position={0}>Sn</Th>
										<Th position={1}>Title</Th>
										<Th position={2}>Author</Th>
										<Th position={3}>Ed</Th>
										<Th position={4}>Publisher</Th>
										<Th position={5}>Call No</Th>
										<Th position={6}>Acc No</Th>
										<Th position={7}>Status</Th>
										<Th position={8}></Th>
									</Tr>
								</Thead>

								<Tbody height='70vh'>
									{data?.data?.map((item, i) => (
										<Tr key={item._id} index={i}>
											<Td position={0} index={i}>
												{state.page * 50 + 1 + i}
											</Td>

											<Td position={1} index={i} fontSize='11px'>
												<div className='flex gap-2 items-center'>
													<img src={item?.image} className='w-[30px] h-[40px] rounded object-cover' alt='Book' />
													<span>{item.nameOfBook}</span>
												</div>
											</Td>

											<Td position={2} index={i}>
												{item.nameOfAuthor}
											</Td>
											<Td position={3} index={i}>
												{item.edition}
											</Td>
											<Td position={4} index={i}>
												{item.nameOfPublisher}
											</Td>
											<Td position={5} index={i}>
												{item.callNo}
											</Td>
											<Td position={6} index={i}>
												{item.accessionNumber}
											</Td>
											<Td position={7} index={i}>
												{item.status === 'unAvailable' ? 'Unavailable' : 'Available'}
											</Td>

											<Td position={8} index={i}>
												<div className='print:hidden'>
													<Button type='update' onClick={() => setItems({ ...items, addBook: true, stockId: item._id })}>
														Edit
													</Button>
												</div>
											</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
						</div>
					</div>
				)}
			</Body>

			{items.addBook && (
				<ModalWrapper>
					<EditBook onCloseModal={() => setItems({ ...items, addBook: false })} refectOrgin={refetch} stockId={items.stockId} onSuccess={() => setItems({ ...items, addBook: false })} />
				</ModalWrapper>
			)}
		</Main>
	);
};
